import React from 'react'
import { useLocation, Link } from 'react-router-dom'

function titleFromSlug(slug) {
    return slug.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

const banners = {
    '/': {
        slides: [
            {
                image: '/img/banner 2.webp',
                title: 'High Quality Digital Solutions',
                subtitle:
                    'Providing accurate scalable and innovative healthcare solutions to improve future scope.',
                ctaText: 'Explore More',
                ctaLink: '/about-us',
                align: 'start',
            },
            {
                image: '/img/banner%20tech.webp',
                title: 'Technology Services Experts & Quality Assurance',
                subtitle:
                    'Skilled professionals committed to delivering high quality testing and care.',
                ctaText: 'Our Services',
                ctaLink: '/service',
                align: 'end',
            },
        ],
    },
    '/about-us': {
        slides: [
            {
                image: '/img/About-us.webp',
                title: 'About 100Eyes Technologies',
                subtitle: 'We build enterprise-grade software and digital solutions for modern businesses.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
    '/service': {
        slides: [
            {
                image: '/img/banner 3.webp',
                title: 'Our Services',
                subtitle: 'Custom software, cloud migration, and managed services tailored to your needs.',
                ctaText: 'View Services',
                ctaLink: '/service',
                align: 'start',
            },
        ],
    },
    '/blogs': {
        slides: [
            {
                image: '/img/banner 5.webp',
                title: 'Insights & Articles',
                subtitle: 'Read our latest articles on technology, best practices and industry trends.',
                ctaText: 'Read Blog',
                ctaLink: '/blogs',
                align: 'end',
            },
        ],
    },
    '/contact-us': {
        slides: [
            {
                image: '/img/contact-us banner.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
    '/business-automation': {
        slides: [
            {
                image: '/img/banner 2.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
    '/content-management-system': {
        slides: [
            {
                image: '/img/cms banner.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
    '/customer-relation-management': {
        slides: [
            {
                image: '/img/banner 5.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
     '/custom-software-development': {
        slides: [
            {
                image: '/img/banner 4.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
     '/digital-promotion': {
        slides: [
            {
                image: '/img/banner 5.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
     '/mobile-app-development': {
        slides: [
            {
                image: '/img/banner 6.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
     '/on-payroll': {
        slides: [
            {
                image: '/img/skillset banner.webp',
                title: 'Get In Touch',
                subtitle: 'Reach out to our sales or support teams to discuss your project.',
                ctaText: 'Contact Us',
                ctaLink: '/contact-us',
                align: 'start',
            },
        ],
    },
}

function getBannerForPath(pathname) {
    // exact match first
    if (banners[pathname]) return banners[pathname]
    // handle category pages
    if (pathname.startsWith('/category/')) {
        const slug = pathname.split('/').pop() || ''
        return {
            slides: [
                {
                    image: '/img/feature.webp',
                    title: titleFromSlug(slug),
                    subtitle: 'Browse our curated selection and launch your online presence in this category.',
                    ctaText: 'Contact Sales',
                    ctaLink: '/contact-us',
                    align: 'start',
                },
            ],
        }
    }
    // fallback to home banner single slide
    return banners['/']
}

export default function PageBanner() {
    const location = useLocation()
    const banner = getBannerForPath(location.pathname)

    return (
        <div className="container-fluid header-carousel px-0 mb-5">
            {/* Carousel Start */}
            <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    {banner.slides.map((slide, idx) => (
                        <div key={idx} className={`carousel-item ${idx === 0 ? 'active' : ''}`}>
                            <img className="w-100 m-0" src={slide.image} alt={slide.title} />
                            <div className="carousel-caption">
                                <div className="container">
                                    <div className={`row justify-content-${slide.align === 'end' ? 'end' : 'start'}`}>
                                        <div className={`col-lg-7 text-${slide.align === 'end' ? 'end' : 'start'}`}>
                                            <h1 className="display-1 text-white animated slideInRight mb-3">{slide.title}</h1>
                                            <p className="mb-5 animated slideInRight">{slide.subtitle}</p>
                                            <Link to={slide.ctaLink} className="btn btn-primary py-3 px-5 animated slideInRight">{slide.ctaText}</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true" />
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true" />
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
            {/* Carousel End */}
        </div>
    )
}
